/**
 * Pluralization utility
 * Returns singular or plural form based on count
 */

/**
 * Simple pluralization
 * @param {number} count - The count value
 * @param {string} singular - Singular form (e.g., "event")
 * @param {string} plural - Plural form (e.g., "events")
 * @returns {string} The appropriate form
 */
export const pluralize = (count, singular, plural = null) => {
  // If plural not provided, add 's' to singular
  const pluralForm = plural || `${singular}s`
  return count === 1 ? singular : pluralForm
}

/**
 * Returns count with pluralized word
 * @param {number} count - The count value
 * @param {string} singular - Singular form
 * @param {string} plural - Optional plural form
 * @returns {string} Count with word (e.g., "1 event" or "2 events")
 */
export const countWithWord = (count, singular, plural = null) => {
  return `${count} ${pluralize(count, singular, plural)}`
}